import React from "react";
import {Box, Colors, Text} from "@bounce/shared/ui";
import {SegmentCategory} from "../../apis/requests/segments/types";
import {DragHandleCell} from "../../components/sortable";
import {SEGMENT_CATEGORY_INFO} from "./segment-form/constants";
import {SegmentCategoryMarker} from "./SegmentCategoryMarker";

export const CATEGORY_HEADER_HEIGHT = 40;
export const CATEGORY_HEADER_ACCENT_WIDTH = 3;
const DRAG_COLUMN_WIDTH = 48;
const RANK_COLUMN_WIDTH = 70;
const RANK_BADGE_SIZE = 28;

export type CategoryHeaderInfo = {
  segmentCategory: SegmentCategory;
  bucketCount: number;
  rank: number | undefined;
};

type Props = CategoryHeaderInfo & {
  top: number;
  style: Pick<React.CSSProperties, "transform" | "transition">;
};

const bucketCountLabel = (count: number) => `${count} bucket${count === 1 ? "" : "s"}`;

export const CategoryHeader = ({segmentCategory, bucketCount, rank, top, style}: Props) => {
  const {label, color, rowBackground} = SEGMENT_CATEGORY_INFO[segmentCategory];
  return (
    <Box
      sx={{
        position: "absolute",
        top,
        left: 0,
        right: 0,
        height: CATEGORY_HEADER_HEIGHT,
        display: "flex",
        alignItems: "center",
        backgroundColor: rowBackground,
        boxShadow: `inset ${CATEGORY_HEADER_ACCENT_WIDTH}px 0 0 ${color}`,
        borderBottom: `1px solid ${Colors.tertiary._200}`,
        zIndex: 1,
      }}
      style={style}
    >
      <Box sx={{width: DRAG_COLUMN_WIDTH, display: "flex", justifyContent: "center", flexShrink: 0}}>
        <DragHandleCell />
      </Box>
      <Box sx={{width: RANK_COLUMN_WIDTH, display: "flex", justifyContent: "center", flexShrink: 0}}>
        <Box
          sx={{
            width: RANK_BADGE_SIZE,
            height: RANK_BADGE_SIZE,
            borderRadius: "8px",
            backgroundColor: Colors.bw.white,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Text size={12} variant="inter600" sx={{color: Colors.grey._700}}>
            {rank ?? "–"}
          </Text>
        </Box>
      </Box>
      <Box sx={{display: "flex", alignItems: "center", gap: 1, px: 1.25}}>
        <SegmentCategoryMarker segmentCategory={segmentCategory} />
        <Text size={14} variant="inter600" sx={{color: Colors.grey._900}}>
          {label}
        </Text>
        <Text size={13} sx={{color: Colors.grey._600}}>
          · {bucketCountLabel(bucketCount)}
        </Text>
      </Box>
    </Box>
  );
};
